import { envVars } from '@/lib/environment/config';
import { PopupProvider } from '@/providers/PopupProvider';
import { ExtensionProvider } from '@infinex-private/connect-web-shared/providers';

export function PopupLayout(props: { children: React.ReactNode }) {
  return (
    <div className="flex h-screen min-h-[620px] flex-col items-center justify-center">
      <div className="relative flex size-full max-w-xl flex-col items-center justify-center">
        <ExtensionProvider
          extensionIdByEnvironment={{
            prod: envVars.PROD_EXTENSION_ID,
            staging: envVars.STAGING_EXTENSION_ID,
          }}
        >
          <PopupProvider>{props.children}</PopupProvider>
        </ExtensionProvider>
      </div>
    </div>
  );
}
